import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

const CancelEvent = (props) => {
  const {
    toggle,
    modal,
    onClick,
    onSelect,
  } = props;

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Cancel Event</ModalHeader>
      <ModalBody>
        <div className="h6">
          Do you want to cancel Event?
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClick}>Yes</Button>
        <Button color="secondary" onClick={onSelect}>No</Button>
      </ModalFooter>
    </Modal>
  );
};

CancelEvent.propTypes = {
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};


export default CancelEvent;
